import React from 'react';
import { useTranslation } from 'react-i18next';
import { FlagRounded } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useSelector } from 'react-redux';
import { LANDING_PAGE_URL } from '@src/configs';
import { CATEGORY_TYPE, PLATFORM_TYPE } from '@src/constants/support';
import { StyledErrorReportButton } from './index.style';

const ErrorReportButton = ({ request = {} }) => {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.auth);
  const { id: requestId, voice } = request;

  const handleOpenErrorReport = (e) => {
    e.stopPropagation();
    const ticketMetadata = {
      requestId,
      voiceCode: voice.code,
      userId: user.id,
    };
    const base64TicketMetadata = btoa(JSON.stringify(ticketMetadata));
    const encodedTicketMetadata = encodeURIComponent(base64TicketMetadata);

    window.open(
      `${LANDING_PAGE_URL}/support?metadata=${encodedTicketMetadata}&platform=${PLATFORM_TYPE.DESKTOP_WEB}&category=${CATEGORY_TYPE.TTS}`,
      '_blank',
    );
  };

  return (
    <StyledErrorReportButton>
      <Button
        className="error-report-button"
        variant="outlined"
        size="small"
        startIcon={<FlagRounded className="flag-icon" />}
        onClick={handleOpenErrorReport}
      >
        <span>{t('errorReport')}</span>
      </Button>
    </StyledErrorReportButton>
  );
};

export default ErrorReportButton;
